import { useCurrentNetwork, useCurrentWallet } from '@mysten/dapp-kit-react'
import { useEffect } from 'react'

import { useCurrentWalletAddress } from './useCurrentWalletAddress'
import { initializeSentrySession } from './sentry-utils'

export const useSentryWalletInit = () => {
  const walletAddress = useCurrentWalletAddress()
  const currentWallet = useCurrentWallet()
  const network = useCurrentNetwork()

  useEffect(() => {
    if (!walletAddress || !currentWallet) {
      return
    }

    initializeSentrySession(walletAddress, network, currentWallet.name)
  }, [currentWallet, network, walletAddress])
}
